import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useColors from "../../../../api/hooks/useColors";
import TextButton from "../../../../components/buttons/TextButton";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { icons, severities } from "../../../stack/environment/icons/iconExport";
import { IntegrationCategory } from "../../../stack/integrations/IntegrationsMapping";

export default function MissingMDMBanner() {
  const colors = useColors();
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      sx={{
        border: `0.5px solid ${colors.alert_info_stroke}`,
        borderRadius: "8px",
        padding: "12px 12px 12px 4px",
        backgroundColor: colors.alert_info_bg,
      }}
    >
      <Box display="flex" alignItems="center">
        <Box padding="0 16px 0 8px" display="flex" alignItems="center">
          <SvgToIcon
            IconLogo={severities.SeverityBackgroundInfoIcon}
            width="24px"
            height="24px"
          />
        </Box>
        <Typography
          variant="subtitle2"
          color={colors.text_primary}
          whiteSpace="nowrap"
        >
          Connect missing MDMs to enable MCP monitoring.
        </Typography>
      </Box>
      <TextButton
        onClick={() => {
          navigate(
            `/inventory/integrations?integrationType=${IntegrationCategory.MDM}`
          );
        }}
        color="primary"
        size="xs"
        endIcon={icons.NewTabIcon}
      >
        Connect MDM
      </TextButton>
    </Box>
  );
}
